import { Component, inject } from '@angular/core';
import { WhiteLabelStateService } from 'app/shared/services/edduca-imob';

/**
 * Footer "Powered by Edduca Imob" — exibido apenas quando há white-label ativo.
 * Pode ser usado tanto na área logada (compact-layout) quanto nas telas de auth.
 */
@Component({
    selector: 'app-footer-powered',
    standalone: true,
    template: `
    @if (wlState.hasWhiteLabel()) {
      <div class="flex items-center justify-center gap-2 py-3 px-4 bg-zinc-900/60 border-t border-zinc-800 text-xs text-white/50 select-none">
        <span>Powered by</span>
        <span class="font-semibold text-white/80">Edduca Imob</span>
      </div>
    }
  `,
    styles: [':host { display: block; }']
})
export class FooterPoweredComponent {
    wlState = inject(WhiteLabelStateService);
}

/**
 * Variante compacta para telas de auth (fundo claro, sem borda superior).
 */
@Component({
    selector: 'app-footer-powered-light',
    standalone: true,
    template: `
    @if (wlState.hasWhiteLabel()) {
      <div class="flex items-center justify-center gap-2 mt-6 text-xs text-slate-500 select-none">
        <span>Powered by</span>
        <span class="font-semibold text-slate-700">Edduca Imob</span>
      </div>
    }
  `,
    styles: [':host { display: block; }']
})
export class FooterPoweredLightComponent {
    wlState = inject(WhiteLabelStateService);
}
